import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { BaseObject } from '../base-object.model';

@HateoasResource('userprofile')
export class UserProfile extends BaseObject {
  public license!: string;
  public preferredUsername!: string;
  public givenName!: string;
  public familyName!: string;
  public locale!: 'en' | 'nl';
  public email!: string;
  public newPassword?: string;
  public twoFactorAuth!: boolean;
  public passKeyEnabled!: boolean;
}
